/* eslint-disable @typescript-eslint/naming-convention */
import { FC } from 'react';
import { RouteObject } from 'react-router-dom';

import { UserRoles } from 'app/constants/user';

export interface RouteBuilderOutput {
  Component: FC;
  path: string;
}

export interface RouteBuilderItem extends RouteBuilderOutput {
  permitOnly?: UserRoles[];
}

export const routeBuilder = ({
  pathNameSpace,
  routes,
  userRoles,
}: {
  pathNameSpace: string;
  routes: RouteBuilderItem[];
  userRoles: number[];
}): RouteBuilderOutput[] =>
  routes
    .filter(route =>
      !route.permitOnly || route.permitOnly.some(id => userRoles.includes(id)))
    .map(route => ({
      Component: route.Component,
      path: `${pathNameSpace}${route.path}`,
    }));

export const mapRouteBuilderToRoutes = ({
  authRoles,
  items,
}: {
  authRoles: number[];
  items: RouteBuilderItem[];
}): RouteObject[] =>
  items
    .filter(item =>
      !item.permitOnly || item.permitOnly.some(id => authRoles.includes(id)))
    .map(item => ({
      element: <item.Component />,
      path: item.path,
    }));
